import axios from 'axios';

import { API_BASE_URL } from 'utils/constants';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handleFetchConvsArchive = async (data) => {
  const res = await axiosInstance.post(
    '/admin/conversations/getConversations',
    data
  );
  return res.data;
};

export const handleFetchUserDetailsConvs = async (data) => {
  const res = await axiosInstance.post(
    '/admin/conversation/getUserDetails',
    data
  );

  return res.data;
};

export const handleOpenConversation = async (data) => {
  const res = await axiosInstance.post(
    '/admin/conversations/reOpenConversation',
    data
  );

  return res.data;
};

export const handleUpdateUserAbout = async (data) => {
  const res = await axiosInstance.post(
    '/admin/users/updateUserInformation',
    data
  );

  return res.data;
};

export const handleExportConvsList = async (data) => {
  const res = await axiosInstance.post('/admin/conversations/export', data);

  return res.data;
};

export const handleExportChatsList = async (data) => {
  const res = await axiosInstance.post(`/admin/chats/export`, data);

  return res.data;
};
